module.exports = __webpack_public_path__ + "static/media/groupChatIcon.7e41d9e9.svg";